module.exports = __webpack_public_path__ + "static/media/typescript.550fbd87.svg";